import { stepMedicalExpensesTugoLookup as expenseLookup } from './claimCodeMapper';

function mapToParentSection() {
  return {};
}

function mapToQuestionnaire() {
  return [];
}

// Generic function to map any type of expense
function mapExpensesByType(data, itemsKey, expenseLookupKey, condition = true) {
  if (!condition || !data[itemsKey] || data[itemsKey].length < 1) {
    return [];
  }
  
   // Check if lookup key exists in expense lookup
  if (!expenseLookup.hasOwnProperty(expenseLookupKey)) {
    console.warn(`Expense lookup key not found: ${expenseLookupKey}`);
    return [];
  }

  const claimCode = expenseLookup[expenseLookupKey].claimCode;
  const expenses = [];

  data[itemsKey].forEach(item => {
    const expense = mapExpenseItem(item, data, claimCode);
    if (!!expense) {
      expenses.push(expense);
    }
  });

  return expenses;
}

function mapToExpenses(data) {
  const expensesSelected = !!data.whatExpensesAreYouClaimingFor && typeof data.whatExpensesAreYouClaimingFor.toJS === 'function'
    ? data.whatExpensesAreYouClaimingFor.toJS()
    : data.whatExpensesAreYouClaimingFor || [];

  const expenseConfigs = [
    {
      items: 'infoOutpatientDoctorOrClinicVisitItems',
      lookup: 'outpatientDoctorOrClinicVisit',
      condition: data.isClaimRelatedToSelfInflictedNo === 'true' 
    },
    {
      items: 'infoOutpatientDoctorOrClinicVisitSelfInflictedInjuriesAndAttemptedSuicideItems',
      lookup: 'isYourClaimRelatedToASelfInflictedInjuryOrSuicideAttemptYes',
      condition: data.isClaimRelatedToSelfInflictedYes === 'true'
    },
    {
      items: 'infodDiagnosticNonMRIItems',
      lookup: 'diagnosticNonMRI',
      condition: data.diagnosticImaging.includes('diagnosticNonMRI')
    },
    {
      items: 'infodDiagnosticMRIItems',
      lookup: 'diagnosticMRI',
      condition: data.diagnosticImaging.includes('diagnosticMRI')
    },
    {
      items: 'infoHospitalizationChargesItems',
      lookup: 'inPatientHospitalExpenses',
      condition: expensesSelected.includes('In Patient Hospital Expenses')
    },
    {
      items: 'infoBloodPlasmaItems',
      lookup: 'bloodPlasmaOrWholeBloodTransfusion',
      condition: expensesSelected.includes('Blood plasma or whole blood (transfusion)')
    },
    {
      items: 'infoAnaesthesiologyItems',
      lookup: 'anaesthesiology',
      condition: expensesSelected.includes('Anaesthesiology')
    },
    {
      items: 'infoDentalSurgeryItems',
      lookup: 'dentalSurgery',
      condition: expensesSelected.includes('Dental Surgery')
    },
    {
      items: 'infoWellBabyCareItems',
      lookup: 'wellBabyCare',
      condition: expensesSelected.includes('Well Baby Care')
    },
    {
      items: 'infoAnnualHealthExamItems',
      lookup: 'annualHealthExam',
      condition: expensesSelected.includes('Annual Health Exam')
    },
    {
      items: 'infoVaccinationExpensesItems',
      lookup: 'vaccinationExpenses',
      condition: expensesSelected.includes('Vaccination Expenses')
    },
    {
      items: 'infoCleftLipAndPalateAssistanceItems',
      lookup: 'cleftLipAndPalateAssistance',
      condition: expensesSelected.includes('Cleft Lip and Palate Assistance')
    },
    {
      items: 'infoMaternityExpenseItems',
      lookup: 'maternityExpense',
      condition: expensesSelected.includes('Maternity Expense')
    },
    {
      items: 'infoOncologyItems',
      lookup: 'oncology',
      condition: expensesSelected.includes('Oncology')
    },
    {
      items: 'infoInPatientHospitalExpensesSelfInflictedInjuriesAndAttemptedSuicideItems',
      lookup: 'isYourClaimRelatedToASelfInflictedInjuryOrSuicideAttemptYes',
      condition: data.isYourClaimRelatedToASelfInflictedInjuryOrSuicideAttempt === 'yes'
    },
    {
      items: 'infoHospitalChargesRelatedToPsychiatricTreatmentItems',
      lookup: 'isYourClaimRelatedToPsychiatricTreatment',
      condition: data.isYourClaimRelatedToPsychiatricTreatment === 'yes'
    },
    {
      items: 'infoHospitalChargesRelatedToHIVItems',
      lookup: 'isYourClaimRelatedToHIV',
      condition: data.isYourClaimRelatedToHIV === 'yes'
    },
    {
      items: 'infoHospitalizationChargesItems',
      lookup: 'isYourClaimRelatedToHIV',
      condition: data.isYourClaimRelatedToHIV === 'no'
    },
  ];

  // Map all expenses using the generic function
  const allExpenses = expenseConfigs.flatMap(config => 
    mapExpensesByType(data, config.items, config.lookup, config.condition)
  );

  return [...allExpenses];
}

function mapExpenseItem(item, itemDate, claimCode) {
  const selectedClaimForArray = (!Array.isArray(item.selectedClaimFor)) ? item.selectedClaimFor.toJS() : item.selectedClaimFor;
  const claimForInsuredIds = selectedClaimForArray.map((claimFor) => claimFor.policyRoleID);
  if (!item || !item.amountClaimed || !item.currency) {
    return null;
  }
  return {
    shortDescription: `${item.descriptionOfItem}`,
    dateOfExpense: item.dateOfExpenses,
    clientCost: item.amountClaimed,
    currency: item.currency,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
    claimForInsuredIds,
    claimForInsureds: selectedClaimForArray,
  };
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepMedicalExpensesTugoDataMapper.js